// components/PageBody/PageBody.tsx
import React from 'react';
import styles from './PageBody.module.css';

interface PageBodyProps {
  children: React.ReactNode;
}

const PageBody: React.FC<PageBodyProps> = ({ children }) => {
  return <div className={styles.body}>{children}</div>;
};

export default PageBody;